import {
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxCurrencyModule } from 'ngx-currency';
import { NG_MODULES } from 'src/app/config/ng-modules';
import { LocalizedDatePipe } from 'src/app/pipes/localized-date.pipe';
import { FormFieldAbstractComponent } from './form-field-abstract.component';
import { FormFieldCheckboxComponent } from './form-field-checkbox';
import { FormFieldDateComponent } from './form-field-date';
import { FormFieldDatetimeComponent } from './form-field-datetime';
import { FormFieldMonetaryAmountComponent } from './form-field-monetary-amount';
import { FormFieldPasswordComponent } from './form-field-password';
import { FormFieldRadioComponent } from './form-field-radio';
import { FormFieldSelectComponent } from './form-field-select';
import { FormFieldTextComponent } from './form-field-text';
import { FormFieldTextareaComponent } from './form-field-textarea';

@NgModule({
  declarations: [
    FormFieldAbstractComponent,
    FormFieldTextComponent,
    FormFieldPasswordComponent,
    FormFieldCheckboxComponent,
    FormFieldSelectComponent,
    FormFieldDatetimeComponent,
    FormFieldDateComponent,
    FormFieldMonetaryAmountComponent,
    FormFieldTextareaComponent,
    FormFieldRadioComponent,
    LocalizedDatePipe,
  ],
  exports: [
    FormFieldTextComponent,
    FormFieldPasswordComponent,
    FormFieldCheckboxComponent,
    FormFieldSelectComponent,
    FormFieldDatetimeComponent,
    FormFieldDateComponent,
    FormFieldMonetaryAmountComponent,
    FormFieldTextareaComponent,
    FormFieldRadioComponent,
    LocalizedDatePipe,
  ],
  imports: [
    ...NG_MODULES,
    NgxCurrencyModule,
    TranslateModule.forChild({ isolate: false }),
    NgSelectModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'EUR',
    },
  ],
})
export class FormFieldsModule {}
